import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Buffer } from 'buffer';
import { AuthenticationService } from "../_services";
import { environment } from "@env/environment";

@Component({
  selector: 'broker-authorize',
  template: ""
})
export class BrokerAuthorizeComponent{
  private token: string;
  constructor(
    private activatedRoute: ActivatedRoute,
    private authorizationService: AuthenticationService
  ) {
    this.token = this.activatedRoute.snapshot.queryParams['token'];
    this.initializeApp();
  }

  private initializeApp = () => {
    let storedUrl = localStorage.getItem('authorizationUrl');
    if (storedUrl) {
      const decodedUrl = Buffer.from(storedUrl, 'base64').toString('utf8');
      localStorage.removeItem('authorizationUrl');
      window.location.href = `${decodedUrl}?token=${this.token}`;
    } else {
      storedUrl = localStorage.getItem('returnUrl');
      if(!storedUrl)
        storedUrl = environment.default_return_url;
      localStorage.removeItem('returnUrl');
      const tokenObject = {
        token: this.token
      }
      const encodedToken = Buffer.from(JSON.stringify(tokenObject)).toString('base64');
      this.authorizationService.redirectWithToken(storedUrl, encodedToken);
    }
  }
}
